var _rect, _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVelocidade(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 70,
    viewBox: "0 0 60 70",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 50,
    rx: 8,
    fill: "#25DC8C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 47.5,
    r: 22.5,
    fill: "#F5F9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 39.5C34.6217 39.5 36.6566 40.3429 38.1569 41.8431C39.6571 43.3434 40.5 45.3783 40.5 47.5C40.5 49.6217 39.6571 51.6566 38.1569 53.1569C36.6566 54.6571 34.6217 55.5 32.5 55.5C30.3783 55.5 28.3434 54.6571 26.8431 53.1569C25.3429 51.6566 24.5 49.6217 24.5 47.5C24.5 45.3783 25.3429 43.3434 26.8431 41.8431C28.3434 40.3429 30.3783 39.5 32.5 39.5V39.5ZM32.5 41.5C30.9087 41.5 29.3826 42.1321 28.2574 43.2574C27.1321 44.3826 26.5 45.9087 26.5 47.5C26.5 49.0913 27.1321 50.6174 28.2574 51.7426C29.3826 52.8679 30.9087 53.5 32.5 53.5C34.0913 53.5 35.6174 52.8679 36.7426 51.7426C37.8679 50.6174 38.5 49.0913 38.5 47.5C38.5 45.9087 37.8679 44.3826 36.7426 43.2574C35.6174 42.1321 34.0913 41.5 32.5 41.5ZM31.5 43.5H33V47.28L35.33 49.61L34.27 50.67L31.5 47.9V43.5ZM19.5 53.5C19.2348 53.5 18.9804 53.3946 18.7929 53.2071C18.6054 53.0196 18.5 52.7652 18.5 52.5C18.5 52.2348 18.6054 51.9804 18.7929 51.7929C18.9804 51.6054 19.2348 51.5 19.5 51.5H23.33C23.64 52.21 24.04 52.88 24.5 53.5H19.5ZM20.5 48.5C20.2348 48.5 19.9804 48.3946 19.7929 48.2071C19.6054 48.0196 19.5 47.7652 19.5 47.5C19.5 47.2348 19.6054 46.9804 19.7929 46.7929C19.9804 46.6054 20.2348 46.5 20.5 46.5H22.55L22.5 47.5L22.55 48.5H20.5ZM21.5 43.5C21.2348 43.5 20.9804 43.3946 20.7929 43.2071C20.6054 43.0196 20.5 42.7652 20.5 42.5C20.5 42.2348 20.6054 41.9804 20.7929 41.7929C20.9804 41.6054 21.2348 41.5 21.5 41.5H24.5C24.04 42.12 23.64 42.79 23.33 43.5H21.5Z",
    fill: "#F7155E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVelocidade);
export default __webpack_public_path__ + "static/media/icon-velocidade.06ac1d4a58500b45ef0c3e96f1b5c191.svg";
export { ForwardRef as ReactComponent };